/**
 * @fileoverview Entity Picker container component
 */
// @ts-nocheck
goog.declareModuleId('yext.ui.components.entitypicker.container.EntityPickerContainer');


import {Button} from '/ui/components/button/button';
import {Cart} from '/ui/components/entitypicker/cart/cart';
import {CartModel} from '/ui/components/entitypicker/cart/cartmodel';
import {ItemTypes} from '/ui/components/entitypicker/container/itemtypes';
import {EntityTypeModel, entityTypeMatchesText} from '/ui/components/entitypicker/datasource/datamodel';
import {EntityList} from '/ui/components/entitypicker/itemlist/entitylist';
import {EntityTypeList} from '/ui/components/entitypicker/itemlist/entitytypelist';
import {FolderList} from '/ui/components/entitypicker/itemlist/folderlist';
import {LabelList} from '/ui/components/entitypicker/itemlist/labellist';
import {PickerTabs} from '/ui/components/entitypicker/tabs/pickertabs';
import {Tab} from '/ui/components/entitypicker/tabs/tab';
import {Picker} from '/ui/components/picker/picker';
import {yext} from '/ui/lib/msg';

import * as entityPickerContainerStyles from '/ui/components/entitypicker/container/entitypickercontainer.module.scss';
import * as a11yStyles from '/ui/utilities/a11y.module.scss';

const ENTITIES_TAB = 'uep-entities-tab';
const FOLDERS_TAB = 'uep-folders-tab';
const LABELS_TAB = 'uep-labels-tab';
const ENTITYTYPES_TAB = 'uep-entitytypes-tab';
const itemTypeToTab = {
  [ItemTypes.ENTITIES]: ENTITIES_TAB,
  [ItemTypes.FOLDERS]: FOLDERS_TAB,
  [ItemTypes.LABELS]: LABELS_TAB,
  [ItemTypes.ENTITYTYPES]: ENTITYTYPES_TAB,
};

/**
 * @typedef {{
 *   allowEntityTypeSelection: ?,
 *   allowedItems: ?,
 *   allowedSelectAllItems: ?,
 *   asFilter: ?,
 *   entityTypes: ?,
 *   initialCart: ?,
 *   locationsOnly: ?,
 *   multiCategory: ?,
 *   onCancel: ?,
 *   onSelect: function(!CartModel): void,
 *   onShowMore: ?,
 *   rootRefCallback: ?,
 *   searcher: ?,
 *   selection: ?,
 *   singleSelect: ?,
 *   isLoading: boolean,
 *   dropdownExpanded: boolean,
 *   handleEntityAddClick?: ?function(),
 *   fullStoryId?: string,
 * }}
 */
let EntityPickerContainerProps;

export class EntityPickerContainer extends React.Component {
  constructor(props) {
    super(props);
    /** @type {EntityPickerContainerProps} */
    this.props;

    this.state = {
      selectedTab: this.getInitialTab(props.initialCart),
      collapseEntities: true,
      cart: props.initialCart,
      searchTerm: '',
    };

    this.rootElement = React.createRef();

    this.selectTab = this.selectTab.bind(this);
    this.removeEntityFromCart = this.removeEntityFromCart.bind(this);
    this.removeEntityTypeFromCart = this.removeEntityTypeFromCart.bind(this);
    this.removeFolderFromCart = this.removeFolderFromCart.bind(this);
    this.removeLabelFromCart = this.removeLabelFromCart.bind(this);
    this.search = this.search.bind(this);
    this.resetCart = this.resetCart.bind(this);
    this.applySelection = this.applySelection.bind(this);
    this.cancelSelection = this.cancelSelection.bind(this);
    this.addAllOfTypeToCart = this.addAllOfTypeToCart.bind(this);

    this.addEntityToCart = this.addEntityToCart.bind(this);
    this.addEntityTypeToCart = this.addEntityTypeToCart.bind(this);
    this.addFolderToCart = this.addFolderToCart.bind(this);
    this.addLabelToCart = this.addLabelToCart.bind(this);
    this.removeAllOfTypeFromCart = this.removeAllOfTypeFromCart.bind(this);

    this.usingEntities = this.props.allowedItems.includes(ItemTypes.ENTITIES);
    this.getPlaceholderText = this.getPlaceholderText.bind(this);
  }

  selectTab(tabId) {
    let newCart = this.state.cart;
    if (!this.props.multiCategory) {
      // TODO(jdelerme): reset warning dialog or something?
      newCart = new CartModel(this.usingEntities);
    }

    this.setState({
      selectedTab: tabId,
      cart: newCart,
    });
  }

  addEntityToCart(entity, entityType) {
    this.updateCart(CartModel.prototype.withEntity, entity, entityType);
  }

  addEntityTypeToCart(entityType) {
    this.updateCart(CartModel.prototype.withEntityType, entityType);
  }

  addFolderToCart(folder, descendantIds) {
    this.updateCart(CartModel.prototype.withFolder, folder, descendantIds);
  }

  addLabelToCart(label) {
    this.updateCart(CartModel.prototype.withLabel, label);
  }

  addAllOfTypeToCart(itemType) {
    this.updateCart(CartModel.prototype.withAll, itemType);
  }

  removeEntityFromCart(entity) {
    this.updateCart(CartModel.prototype.withoutEntity, entity);
  }

  removeEntityTypeFromCart(entityType) {
    this.updateCart(CartModel.prototype.withoutEntityType, entityType);
  }

  removeFolderFromCart(folder) {
    this.updateCart(CartModel.prototype.withoutFolder, folder);
  }

  removeLabelFromCart(label) {
    this.updateCart(CartModel.prototype.withoutLabel, label);
  }

  removeAllOfTypeFromCart(itemType) {
    this.updateCart(CartModel.prototype.withoutAll, itemType);
  }

  updateCart(updateFunc, ...args) {
    if (this.props.singleSelect) {
      this.setState(
        {cart: updateFunc.apply(new CartModel(this.usingEntities), args)},
        this.applySelection);
    } else {
      this.setState(state => ({cart: updateFunc.apply(state.cart, args)}));
    }
  }

  search(term) {
    this.props.searcher(term);
    this.setState({collapseEntities: !term.length, searchTerm: term});
  }

  resetCart() {
    this.setState({cart: new CartModel(this.usingEntities)});
  }

  applySelection() {
    if (this.props.onSelect) {
      this.props.onSelect(this.state.cart);
    }
  }

  cancelSelection() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
    this.setState((state, props) => ({
      selectedTab: this.getInitialTab(props.initialCart),
      cart: props.initialCart,
    }));
  }

  componentDidMount() {
    this.rootElement.current.addEventListener(
      'uep-reset',
      e => {
        this.resetCart();
        if (e.detail.apply) {
          this.applySelection();
        }
      });

    if (this.props.rootRefCallback) {
      this.props.rootRefCallback(this.rootElement.current);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.initialCart != prevProps.initialCart) {
      this.setState(
        (state, props) => ({
          selectedTab: this.getInitialTab(props.initialCart),
          cart: props.initialCart,
        }));
    }
    if (prevProps.dropdownExpanded && (!this.props.dropdownExpanded)) {
      this.setState((state, props) => ({
        selectedTab: this.getInitialTab(props.initialCart),
        cart: props.initialCart,
      }));
    }
  }

  getInitialTab(selection) {
    const allowEntities = this.props.allowedItems.includes(ItemTypes.ENTITIES);
    const allowFolders = this.props.allowedItems.includes(ItemTypes.FOLDERS);
    const allowLabels = this.props.allowedItems.includes(ItemTypes.LABELS);
    const allowEntityTypes = this.props.allowedItems.includes(ItemTypes.ENTITYTYPES);

    if (!selection) {
      return itemTypeToTab[this.props.allowedItems[0]];
    }

    if (selection.allSelected.length > 0) {
      return itemTypeToTab[selection.allSelected[0]];
    }

    if (allowEntities && (selection.entityTypes.length > 0 || selection.entities.length > 0)) {
      return ENTITIES_TAB;
    } else if (allowFolders && selection.folders.length > 0) {
      return FOLDERS_TAB;
    } else if (allowLabels && selection.labels.length > 0) {
      return LABELS_TAB;
    } else if (allowEntityTypes && selection.entityTypes.length > 0) {
      return ENTITYTYPES_TAB;
    } else {
      return itemTypeToTab[this.props.allowedItems[0]];
    }
  }

  getPlaceholderText() {
    const {
      locationsOnly: locOnly,
      allowedItems: [], // allowedItems should always be set to a default value in the parent prop, but do this to fail safely.
    } = this.props;
    const allowEntities = this.props.allowedItems.includes(ItemTypes.ENTITIES);
    const allowFolders = this.props.allowedItems.includes(ItemTypes.FOLDERS);
    const allowLabels = this.props.allowedItems.includes(ItemTypes.LABELS);
    const allowEntityTypes = this.props.allowedItems.includes(ItemTypes.ENTITYTYPES);
    // Remember to retain the order of cases within each of these switch statements, since !allow... are omitted
    if (allowEntities) {
      if (locOnly) {
        switch (true) {// locOnly && allowEntities
          case allowFolders && allowLabels:
            return yext.msg('Search locations, folders, and labels');
          case allowFolders:
            return yext.msg('Search locations and folders');
          case allowLabels:
            return yext.msg('Search locations and labels');
          default:
            return yext.msg('Search locations');
        }
      } else { // if !locOnly
        switch (true) {// !locOnly && allowEntities
          case allowFolders && allowLabels:
            return yext.msg('Search entities, folders, and labels');
          case allowFolders:
            return yext.msg('Search entities and folders');
          case allowLabels:
            return yext.msg('Search entities and labels');
          default:
            return yext.msg('Search entities');
        }
      }
    } else { // if !allowEntities
      switch (true) {// !locOnly && allowEntities
        case allowEntityTypes && allowFolders && allowLabels:
          return yext.msg('Search entity types, folders, and labels');
        case allowEntityTypes && allowFolders:
          return yext.msg('Search entity types and folders');
        case allowEntityTypes && allowLabels:
          return yext.msg('Search entity types and labels');
        case allowFolders && allowLabels:
          return yext.msg('Search folders and labels');
        case allowEntityTypes:
          return yext.msg('Search entity types');
        case allowFolders:
          return yext.msg('Search folders');
        case allowLabels:
          return yext.msg('Search labels');
      }
    }
    console.warn('UEP: Searchbar props may be invalid. Searchbar placeholder text set to fallback.');
    return 'Search';
  }

  render() {
    const cartShown = !this.props.singleSelect;
    const tabsShown = this.props.allowedItems.length > 1;
    const allowEntities = this.props.allowedItems.includes(ItemTypes.ENTITIES);
    const allowFolders = this.props.allowedItems.includes(ItemTypes.FOLDERS);
    const allowLabels = this.props.allowedItems.includes(ItemTypes.LABELS);
    const allowEntityTypes = this.props.allowedItems.includes(ItemTypes.ENTITYTYPES);
    const canSelectAll = itemType => !this.props.asFilter
      && !this.state.searchTerm
      && this.props.allowedSelectAllItems.includes(itemType)
      && !this.state.cart.allSelected.includes(itemType);

    const {filteredTypes, matchedEntityTypes} = filterEntitiesWithCartAndSearch(
      this.props.data.entities.types,
      this.state.cart,
      this.props.singleSelect,
      this.state.searchTerm,
    );
    return (
      <div
        className={`uep-root${this.props.singleSelect ? ' uep-single-select' : ''}`}
        ref={this.rootElement}
      >
        <Picker
          displayCart={!this.props.singleSelect}
          onApply={this.applySelection}
          onCancel={this.cancelSelection}
          onSearch={this.search}
          searchPlaceholder={this.getPlaceholderText()}
          searchTerm={this.state.searchTerm}
          smallFont={true}
          fullStoryId={this.props.fullStoryId}
          selectFromSection={
            <div>
              {tabsShown
                && <PickerTabs>
                  {allowEntities
                    && <Tab id={ENTITIES_TAB} selectedTab={this.state.selectedTab} selectHandler={this.selectTab}>
                      {this.props.locationsOnly ? yext.msg('Locations') : yext.msg('Entities')} ({this.props.data.entities.total})
                    </Tab>
                  }
                  {allowFolders
                    && <Tab id={FOLDERS_TAB} selectedTab={this.state.selectedTab} selectHandler={this.selectTab}>
                      {yext.msg('Folders')} ({this.props.data.folders.total})
                    </Tab>
                  }
                  {allowLabels
                    && <Tab id={LABELS_TAB} selectedTab={this.state.selectedTab} selectHandler={this.selectTab}>
                      {yext.msg('Labels')} ({this.props.data.labels.total})
                    </Tab>
                  }
                  {allowEntityTypes
                    && <Tab id={ENTITYTYPES_TAB} selectedTab={this.state.selectedTab} selectHandler={this.selectTab}>
                      {yext.msg('Entity Types')} ({this.props.data.entities.types.length})
                    </Tab>
                  }
                </PickerTabs>
              }
              <div className="uep-list-container">
                {allowEntities
                  && <TabContent
                    id={ENTITIES_TAB}
                    selectedTab={this.state.selectedTab}
                    isLoading={this.props.isLoading}
                    addItemText={yext.msg('+ Add Entity')}
                    addItemCallback={this.props.handleEntityAddClick}
                  >
                    {canSelectAll(ItemTypes.ENTITIES)
                      && <button
                        type="button"
                        className="uep-item uep-select-all"
                        onClick={() => this.addAllOfTypeToCart(ItemTypes.ENTITIES)}
                      >
                        {yext.msg('Select All Entities')}
                      </button>
                    }
                    <EntityList
                      types={filteredTypes}
                      matchedEntityTypes={matchedEntityTypes}
                      locationsOnly={this.props.locationsOnly}
                      initialCollapsed={this.state.collapseEntities}
                      showMoreHandler={this.props.onShowMore}
                      canSelectTypes={this.props.allowEntityTypeSelection && !this.state.searchTerm}
                      entityTypeClickHandler={this.addEntityTypeToCart}
                      entityClickHandler={this.addEntityToCart}
                    />
                  </TabContent>
                }
                {allowFolders
                  && <TabContent
                    id={FOLDERS_TAB}
                    selectedTab={this.state.selectedTab}
                    isLoading={this.props.isLoading}
                  >
                    {canSelectAll(ItemTypes.FOLDERS)
                      && <button
                        type="button"
                        className="uep-item uep-select-all"
                        onClick={() => this.addAllOfTypeToCart(ItemTypes.FOLDERS)}
                      >
                        {yext.msg('Select All Folders')}
                      </button>
                    }
                    <FolderList
                      folders={this.props.data.folders.items}
                      hiddenFolders={this.state.cart.folders}
                      allSelected={this.state.cart.allSelected.includes(ItemTypes.FOLDERS)}
                      folderClickHandler={this.addFolderToCart} />
                  </TabContent>
                }
                {allowLabels
                  && <TabContent
                    id={LABELS_TAB}
                    selectedTab={this.state.selectedTab}
                    isLoading={this.props.isLoading}
                  >
                    {canSelectAll(ItemTypes.LABELS)
                      && <button
                        type="button"
                        className="uep-item uep-select-all"
                        onClick={() => this.addAllOfTypeToCart(ItemTypes.LABELS)}
                      >
                        {yext.msg('Select All Labels')}
                      </button>
                    }
                    <LabelList
                      labels={filterLabelsWithCart(this.props.data.labels.items, this.state.cart)}
                      labelClickHandler={this.addLabelToCart} />
                  </TabContent>
                }
                {allowEntityTypes
                  && <TabContent
                    id={ENTITYTYPES_TAB}
                    selectedTab={this.state.selectedTab}
                    isLoading={this.props.isLoading}
                  >
                    {canSelectAll(ItemTypes.ENTITYTYPES)
                      && <button
                        type="button"
                        className="uep-item uep-select-all"
                        onClick={() => this.addAllOfTypeToCart(ItemTypes.ENTITYTYPES)}
                      >
                        {yext.msg('Select All Entity Types')}
                      </button>
                    }
                    <EntityTypeList
                      types={filterEntityTypesWithCart(this.props.data.entities.types, this.state.cart)}
                      entityTypeClickHandler={this.addEntityTypeToCart} />
                  </TabContent>
                }
              </div>
            </div>
          }
          selectedSection={cartShown
            && <div className="uep-cart">
              <Cart items={this.state.cart}
                locationsOnly={this.props.locationsOnly}
                asFilter={this.props.asFilter}
                allowedItems={this.props.allowedItems}
                removeEntityHandler={this.removeEntityFromCart}
                removeEntityTypeHandler={this.removeEntityTypeFromCart}
                removeFolderHandler={this.removeFolderFromCart}
                removeLabelHandler={this.removeLabelFromCart}
                removeAllOfTypeHandler={this.removeAllOfTypeFromCart}
                resetHandler={this.resetCart} />
            </div>}
        />
      </div>
    );
  }
}

/**
 * @param {{
 *   id: string,
 *   selectedTab: string,
 *   isLoading: boolean,
 *   addItemText?: string,
 *   addItemCallback?: ?function(),
 *   children: (React.ReactNode|undefined),
 * }} props
 * @returns {React.ReactElement}
 */
function TabContent({
  id,
  selectedTab,
  isLoading,
  addItemText,
  addItemCallback,
  children,
}) {
  // NOTE(amullings): It's not clear if an ARIA live region would be appropriate
  // here, since in many cases the UEP will be loading data before the user even
  // interacts with it.
  const loadingSpinner = (
    <div className="uep-loading">
      <span className={a11yStyles.srOnly}>{yext.msg('Loading...')}</span>
    </div>
  );

  return (
    <>
      <div id={id} className={selectedTab === id ? 'uep-list-root' : 'uep-list-hidden'}>
        {isLoading ? loadingSpinner : children}
      </div>
      {addItemText && addItemCallback
        && selectedTab === id && <div className={entityPickerContainerStyles.addItemButton}>
        <Button tid={`add-item-${id}`}
          onClick={addItemCallback}
          context="ghost"
          size="small"
          chromeless>
          {addItemText}
        </Button>
      </div>}
    </>
  );
}

function filterLabelsWithCart(labels, cart) {
  if (cart.allSelected.includes(ItemTypes.LABELS)) {
    return [];
  }

  return labels.filter(label => !cart.labels.some(l => l.id === label.id));
}

/**
 * @param {!Array<!EntityTypeModel>} entityTypes
 * @param {CartModel} cart
 * @param {boolean} isSingleSelect
 * @param {string} searchTerm
 * @returns {{
 *   filteredTypes: !Array<!EntityTypeModel>,
 *   matchedEntityTypes: !Set<number>,
 * }}
 */
function filterEntitiesWithCartAndSearch(entityTypes, cart, isSingleSelect, searchTerm) {
  const filteredTypes = [];
  const matchedEntityTypes = new Set();
  if (cart.allSelected.includes(ItemTypes.ENTITIES)) {
    return {filteredTypes, matchedEntityTypes};
  }
  for (const type of entityTypes) {
    if (cart.entityTypes.some(t => t.id === type.id)) {
      continue;
    }

    const searchMatches = entityTypeMatchesText(type, searchTerm);
    if (type.entities.length === 0 && !searchMatches) {
      continue;
    }
    if (searchMatches) {
      matchedEntityTypes.add(type.id);
    }

    const entityNotPresentInCart = e => isSingleSelect || !cart.entities.some(c => c.id === e.id);
    const filteredEntities = type.entities.filter(entityNotPresentInCart);
    // NOTE(amullings): Should this use the EntityTypeModel constructor?
    filteredTypes.push({
      total: type.total,
      id: type.id,
      label: type.label,
      apiName: type.apiName,
      entities: filteredEntities,
      nextPageQuery: type.nextPageQuery,
    });
  }
  return {filteredTypes, matchedEntityTypes};
}

function filterEntityTypesWithCart(entityTypes, cart) {
  if (cart.allSelected.includes(ItemTypes.ENTITYTYPES)) {
    return [];
  }

  return entityTypes.filter(type => !cart.entityTypes.some(t => t.id === type.id));
}
